export default __webpack_public_path__ + "static/slide7-tablet-8331553a9eddd4742c615e66f88583fa.png";